import {Grid, OptionsIcon, Typography, UnstableCard as Paper} from '@logistics-frontend/blocks'
import React from 'react'

import {Body, CodeConfirmationRequirement, Header, ToggleTitle} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import {useVerticalOptions} from './hooks'
import {ReturnPointModal} from './ReturnPointModal/ReturnPointModal'
import {ReturnPointRequirement} from './ReturnPointRequirement/ReturnPointRequirement'
import {RouteChange} from './RouteChange/RouteChange'
import {VerticalRequirements} from './VerticalRequirements/VerticalRequirements'

export function VerticalOptions({vertical}: {vertical: string}): React.ReactElement {
  const {
    isAdditionalRequirementsVisible,
    toggleVisibilityHandler,
    acceptReturnPointModalHandler,
    isReturnPointModalOpen,
    isRouteChangeVisible,
    closeReturnPointModalHandler,
    openReturnPointModal,
    handleRequirementChange,
    shouldShowAdditionalOptions,
  } = useVerticalOptions(vertical)

  return (
    <Paper radius="L">
      <Grid size="m" container>
        <Grid xs={12} item>
          <Header lead={<OptionsIcon />}>{i18n('cargo.create.form.options', 'Опции')}</Header>
        </Grid>
        {isRouteChangeVisible && (
          <Grid xs={12} item>
            <Body
              lead={
                <Typography mt="m" thickness="medium" variant="body2">
                  {i18n('cargo.create.rout-change.route', 'Маршрут')}
                </Typography>
              }
              tail={<RouteChange />}
            />
          </Grid>
        )}
        <Grid xs={12} item>
          <Body
            lead={
              <>
                <Typography mt="s" thickness="medium" variant="body2">
                  {i18n('cargo.create.default_requirements.options', 'Опции')}
                </Typography>
                {shouldShowAdditionalOptions && (
                  <ToggleTitle
                    data-e2e="tariff-default-requirements-opener"
                    isOpened={isAdditionalRequirementsVisible}
                    onClick={toggleVisibilityHandler}
                    title={i18n('cargo.create.additional-requirements.title', 'Дополнительно')}
                  />
                )}
              </>
            }
            tail={
              <VerticalRequirements
                onChange={handleRequirementChange}
                showLastElementBorder={isAdditionalRequirementsVisible}
              />
            }
          />
          {shouldShowAdditionalOptions && isAdditionalRequirementsVisible && (
            <Body
              lead={
                <Typography color="main" mt="m" thickness="medium" variant="caption1">
                  {i18n('cargo.create.return-requirements.title', 'Возврат')}
                </Typography>
              }
              tail={
                <>
                  <ReturnPointRequirement onClick={openReturnPointModal}>
                    {/** Нужно физически делать unmount, чтобы форма не сохраняла своего состояния после закрытия модального окна */}
                    {isReturnPointModalOpen && (
                      <ReturnPointModal
                        onAccept={acceptReturnPointModalHandler}
                        onClose={closeReturnPointModalHandler}
                      />
                    )}
                  </ReturnPointRequirement>
                  <CodeConfirmationRequirement noBorder />
                </>
              }
            />
          )}
        </Grid>
      </Grid>
    </Paper>
  )
}
